import { useTranslation } from 'react-i18next';

export const Introduction: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col rounded-lg bg-white p-8">
      <div className="font-semibold text-sm">
        <p>{t('page.mockTest.testIntro.title')}</p>
        <p>{t('page.mockTest.testIntro.testIntroductionDescription')}</p>
        <p>{t('page.mockTest.testIntro.testIntroductionBullet1')}</p>
        <img className="mt-5" src="/images/timer.png" />
        <p className="mt-5">{t('page.mockTest.testIntro.testIntroductionBullet2')}</p>
        <p>{t('page.mockTest.testIntro.testIntroductionBullet3')}</p>
        <p>{t('page.mockTest.testIntro.testIntroductionBullet4')}</p>
        <p>{t('page.mockTest.testIntro.testIntroductionBullet5')}</p>
      </div>
    </div>
  );
};
